const TableStatus = {
  FREE: 'Verde',
  OCCUPIED: 'Rosu'
}

export default TableStatus
